var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const ChangeRate = (_a) => {
    var { currentValue, previousValue } = _a, otherProps = __rest(_a, ["currentValue", "previousValue"]);
    let content;
    if (previousValue > 0) {
        const rate = ((currentValue - previousValue) / previousValue) * 100;
        const faArrowClass = rate >= 0 ? "up text-success" : "down text-danger";
        content = (_jsxs(_Fragment, { children: [_jsx("span", { className: "fa mr-1 fa-chevron-" + faArrowClass, "aria-hidden": "true" }), Math.abs(rate).toFixed(2), "%"] }));
    }
    else {
        content = null;
    }
    return _jsx("div", { className: "text-muted", children: content });
};
export default ChangeRate;
